import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isTableNode } from "@lexical/table";
import {
  $getPreviousSelection,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  type LexicalNode,
  SELECTION_CHANGE_COMMAND,
} from "lexical";
import { useEffect } from "react";
import { $isDataTableNode } from "../../../nodes/data-table-node";

export const useShowGridLines = (): void => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      SELECTION_CHANGE_COMMAND,
      () => {
        const prev = $getPreviousSelection();
        if ($isRangeSelection(prev)) {
          prev.anchor
            .getNode()
            .getParents()
            .map((p: LexicalNode) => {
              if ($isTableNode(p)) {
                editor.getElementByKey(p.getKey())?.classList.remove("show-grid-lines");
              }
            });
        }
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.anchor
            .getNode()
            .getParents()
            .map((p: LexicalNode) => {
              if ($isTableNode(p) && !$isDataTableNode(p)) {
                editor.getElementByKey(p.getKey())?.classList.add("show-grid-lines");
              }
            });
        }

        return false;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  });

  return;
};
